import React, { useState } from "react";
import {
  Box,
  Flex,
  Image,
  VStack,
  Button,
  Spinner,
  useToast,
  Checkbox,
  Text,
} from "@chakra-ui/react";
import axios from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";

import logo from "../../assets/svgs/logo.svg";
import FormikInput from "components/formikInput";
import kidsImage from "../../assets/intro-image.png";

const RegisterPage = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const { rejected_item_action, discount, charity } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name cannot be empty"),
      lastName: Yup.string().required("Last name cannot be empty"),
      email: Yup.string()
        .email("Invalid Email")
        .required("Email cannot be empty"),
    }),
    onSubmit: (values) => handleRegister(values),
  });

  const handleRegister = async (values) => {
    setIsLoading(true);
    try {
      const data = {
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.email,
        rejected_item_action: rejected_item_action,
        discount: discount,
        charity: charity,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/register`,
        data
      );
      if (response.status === 200) {
        toast({
          title: "Registration Successful",
          description:
            "Thanks for signing up! We’ll get in touch with you shortly.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        navigate("/thank-you");
      }
    } catch (e) {
      toast({
        title: "Registration Failed",
        description: e?.response?.data?.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      border="1px solid #2a4567"
      position="relative"
      boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
    >
      {/* Left Content */}
      <Box
        justifyContent="center"
        alignItems="center"
        display={"flex"}
        flex="0 0 100%"
      >
        <VStack align="flex-center" spacing={4} width={425}>
          <Image src={logo} width={"425px"} height={"100px"} />
          <VStack align="flex-center" spacing={6}>
            <FormikInput
              name="firstName"
              type="text"
              label="First Name"
              placeholder={"Enter Your First Name"}
              formik={formik}
            />
            <FormikInput
              name="lastName"
              type="text"
              label="Last Name"
              placeholder={"Enter Your Last Name"}
              formik={formik}
            />
            <FormikInput
              name="email"
              type="text"
              label={"Email Address"}
              placeholder={"Enter Your Email Address"}
              formik={formik}
            />
            <Button
              bgColor={"#000"}
              colorScheme="#456EFF"
              borderRadius={"12px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              lineHeight={"20px"}
              color={"#FFFFFF"}
              textAlign={"center"}
              w={"100%"}
              h={"50px"}
              marginTop={3}
              onClick={formik.handleSubmit}
              isDisabled={isLoading}
              textTransform={"uppercase"}
            >
              {isLoading ? <Spinner /> : "SEND REQUEST"}
            </Button>
          </VStack>
        {/* <Flex gap={2} mt={4} paddingLeft={2}>
          <Checkbox />
          <Text
            color={"#000000"}
            fontFamily={"PlusJakartaSansMedium"}
            fontSize={"12px"}
            lineHeight={"18px"}
          >
            I have read all the Terms and Conditions of KC
          </Text>
        </Flex> */}
        </VStack>
      </Box>
      {/* Right Image */}
      {/* <Box
         flex="0 0 30%"
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        paddingRight={10}
      >
        <Image
          src={kidsImage}
          alt="Kids Fashion"
          objectFit="cover"
          width="100%"
          height="100%"
        />
      </Box> */}
    </Flex>
  );
};

export default RegisterPage;
